
import inputNumber from "./inputNumber.vue"
import { getMax, fen2Yuan, getNumber, getSmallNumber, showMessage } from "./js/common.js"
import { trackSelectItem } from "@/utils/track"
export default {
  name: "DisabledGoods",
  components: {
    inputNumber
  },
  props: {
    item: {
      type: Object,
      default: () => {}
    },
    edit: {
      type: Boolean,
      default: false
    },
    lineShow: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  computed: {},
  methods: {
    getMax,
    getNumber,
    getSmallNumber,
    trackSelectItem,
    handleOverMaximum() {
      showMessage(this.$t("cart.maximumStockTips"))
    },
    toProductDetail(item) {
      this.trackSelectItem(item, () => {
        this.$navigation.push({
          path: `${this.MAIN_PATH}/p/${encodeURIComponent(item.wareName)}/i/${item.skuId}.html`
        })
      })
    },
    handleNumChange(value, item) {
      // 当商品数量为0的时候，删除当前的商品
      // if (value>=0) {
      //   this.$emit("deleteCurrent", value, item)
      // }
      this.$emit("deleteCurrent", value, item)
    },
    toggleWareSelect(item) {
      if (!this.edit) return
      this.$emit("toggleWareSelectDisable", item)
      // this.$emit("toggleWareSelectDisable", {
      //   items: [item]
      // })
    }
  }
}
